import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ModalService } from "../../../../services/modal.service";
import { PaymentViewDataService } from "../../services/payment-view-data.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { iinValidator } from "../../../../validators/iin.validator";
import { CreatePaymentViewDto } from "../../models/payment-view.models";
import { UnsubscribeService } from "src/app/services/unsubscribe.service";
import { takeUntil } from "rxjs";

@Component({
  selector: "app-add-payment-view-dialog",
  templateUrl: "./add-payment-view-dialog.component.html",
  styleUrls: ["./add-payment-view-dialog.component.scss"],
  providers: [UnsubscribeService],
})
export class AddPaymentViewDialogComponent implements OnInit {
  @Input() paymentId?: number;

  @Output() sendEvent: EventEmitter<void> = new EventEmitter<void>();

  form!: FormGroup;

  isActivePayment = true;

  isSending = false;

  constructor(
    private modalService: ModalService,
    private paymentViewDataService: PaymentViewDataService,
    private unsubscribe$: UnsubscribeService
  ) {}

  ngOnInit() {
    this.initForm();
  }

  initForm(): void {
    this.form = new FormGroup({
      accountRecipient: new FormControl("", [Validators.required]),
      paymentNameFormControl: new FormControl("", [Validators.required]),
      recipientFormControl: new FormControl("", [Validators.required]),
      binFormControl: new FormControl("", [Validators.required, Validators.minLength(12), iinValidator()]),
      codeFormControl: new FormControl("", [Validators.minLength(6)]),
      codeDestinationFormControl: new FormControl("", [Validators.required, Validators.minLength(3)]),
      bankRecipient: new FormControl("", [Validators.required, Validators.minLength(8) ]),
      moneyRemitter: new FormControl("", [Validators.required]),
      infoLine: new FormControl("", [Validators.required]),
    });
  }

  get infoLineRequiredError() {
    return this.form.get("infoLine")?.hasError("required");
  }

  get accountRecipientRequiredError() {
    return this.form.get("accountRecipient")?.hasError("required");
  }

  get paymentNameRequiredError() {
    return this.form.get("paymentNameFormControl")?.hasError("required");
  }

  get recipientRequiredError() {
    return this.form.get("recipientFormControl")?.hasError("required");
  }

  get binRequiredError() {
    return this.form.get("binFormControl")?.hasError("required");
  }

  get binFormatError() {
    return this.form.get("binFormControl")?.hasError("minlength");
  }

  get codeFormFormatError() {
    return this.form.get("codeFormControl")?.hasError("minlength");
  }

  get codeDestinationRequiredError() {
    return this.form.get("codeDestinationFormControl")?.hasError("required");
  }

  get codeDestinationFormatError() {
    return this.form.get("codeDestinationFormControl")?.hasError("minlength");
  }

  get bankRecipientRequiredError() {
    return this.form.get("bankRecipient")?.hasError("required");
  }

  get bankRecipientFormatError() {
    return this.form.get("bankRecipient")?.hasError("minlength");
  }

  get moneyRemitterFormatError() {
    return this.form.get("moneyRemitter")?.hasError("required");
  }

  sendForm() {
    this.isSending = true;
    const data: CreatePaymentViewDto = {
      recipient_account: this.form.get("accountRecipient")?.value,
      is_blocked: !this.isActivePayment,
      payment_type_name: this.form.get("paymentNameFormControl")?.value,
      BIN_beneficiary: this.form.get("binFormControl")?.value,
      recipient: this.form.get("recipientFormControl")?.value,
      budget_classification_code: this.form.get("codeFormControl")?.value,
      payment_purpose_code: this.form.get("codeDestinationFormControl")?.value,
      recipient_bank: this.form.get("bankRecipient")?.value,
      money_remitter_code: this.form.get("moneyRemitter")?.value,
      info_line: this.form.get("infoLine")?.value,
    };

    this.paymentViewDataService
      .createPaymentView(data)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: () => {
          this.sendEvent.emit();
          this.isSending = false;
          this.modalService.closeModal();
        },
        error: () => {
          this.isSending = false;
        },
      });
  }

  toUpperCase(formControl: string) {
    this.form.patchValue({
      [formControl]: this.form.get(formControl)?.value.toUpperCase(),
    });
  }

  closeModal() {
    this.modalService.closeModal();
  }
}
